//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    anchorName: String,
    buttonText: String,
    leftAlign: {
      type: Boolean,
      default: false
    }
  }
}
